/**
 * Formats a 10-digit phone number string into (123) 456-7890 format.
 * @param phoneNumber A string of 10 digits.
 * @returns A formatted phone number string or the original input if invalid.
 */
export function formatPhoneNumber(phoneNumber: string): string {
    // Remove any non-digit characters from the input
    const cleaned = phoneNumber.replace(/\D/g, '');
    // Check if the cleaned number is valid (10 digits)
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumber;
}
